import React from 'react'
import _ from 'lodash'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { TextField } from '@mui/material'
import { withTranslation } from 'react-i18next'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import DeleteDialog from '../../DeleteDialog'
import 'react-block-ui/style.css'
import { authContext } from '../../../contexts/AuthContext'
import CPDeleteIconButton from '../../Utils/CPDeleteIconButton'
import CPEditIconButton from '../../Utils/CPEditIconButton'
import CPSettingsIconButton from '../../Utils/CPSettingsIconButton'
import Permissions from './Permissions'
import { apiUrl } from '../../../config/api'

class UserListItem extends React.Component {
  // Fila de lista de usuario para el admin cliente

  constructor() {
    super()

    this.state = {
      settings: {},
      edit: {},
      delete: {},
      reset: {},
      snackbarInfoOpen: false
    }
  }

  static contextType = authContext

  handleSettingsOpen = (user) => {
    this.setState({
      settings: user
    })
  }

  handleSettingsClose = () => {
    this.setState({
      settings: {}
    })
  }

  handleEditOpen = (user) => {
    this.setState({
      edit: user
    })
  }

  handleEditClose = () => {
    this.setState({
      edit: {}
    })
  }

  handleDeleteOpen = (user) => {
    this.setState({
      delete: user
    })
  }

  handleResetOpen = (user) => {
    this.setState({
      reset: user
    })
  }

  handleResetClose = () => {
    this.setState({
      reset: {}
    })
  }

  handleDialogClose = () => {
    this.setState({
      edit: {},
      delete: {}
    })
  }

  handleSnackbarClose = () => {
    this.setState({
      snackbarInfoOpen: false
    })
  }

  update = (user) => {
    user.first_name = document.getElementById('edit_firstName').value
    user.last_name = document.getElementById('edit_lastName').value
    user.email = document.getElementById('edit_email').value
    user.phone = document.getElementById('edit_phone').value
    user.mobile = document.getElementById('edit_mobile').value
    user.loggedUserId = this.context.auth.user.id
    user.brandLabel = window.$brand

    let url = apiUrl('UpdateUser')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(user)
    })
      .then((res) => console.log(res))
      .then((success) => {
        console.log('Update successful')
      })
      .catch((error) => console.log(error))

    this.handleEditClose()
  }

  delete = (user) => {
    user.loggedUserId = this.context.auth.user.id
    user.brandLabel = window.$brand

    let url = apiUrl('DeleteUser')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(user)
    })
      .then((res) => console.log(res))
      .then((success) => {
        console.log('Delete successful')
      })
      .catch((error) => console.log(error))

    this.props.cardDeleteHandler(user)
  }

  resetPassword = (user) => {
    user.brandLabel = window.$brand
    let url = apiUrl('ResetPassword')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(user)
    })
      .then((res) => console.log(res))
      .then((success) => {
        console.log('Reset successful')
        this.setState({
          snackbarInfoOpen: true
        })
      })
      .catch((error) => console.log(error))

    this.handleResetClose()
  }

  render() {
    const { t, user } = this.props

    return (
      <ListItem
        divider
        secondaryAction={
          user.type !== 'client_admin' && (
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <CPSettingsIconButton
                onClick={() => this.handleSettingsOpen(user)}
              />
              <CPEditIconButton onClick={() => this.handleEditOpen(user)} />
              <CPDeleteIconButton
                onClick={() => this.handleDeleteOpen(user)}
              />
            </Box>
          )
        }
      >
        <ListItemText
          primary={`${user.first_name} ${user.last_name}`}
          secondary={user.email}
        />

        <Dialog
          open={!_.isEmpty(this.state.reset)}
          onClose={this.handleResetClose}
        >
          <DialogTitle>{t('reset_password')}</DialogTitle>
          <DialogContent>
            <p>{t('reset_password_caption')}</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleResetClose}>{t('Cancel')}</Button>
            <Button onClick={() => this.resetPassword(this.state.reset)}>
              {t('Accept')}
            </Button>
          </DialogActions>
        </Dialog>
        <DeleteDialog
          item={this.state.delete}
          title={t('delete_user')}
          caption={t('delete_user_caption')}
          targetFunc={this.delete}
          handleDialogClose={this.handleDialogClose}
        />
        <Dialog
          open={!_.isEmpty(this.state.edit)}
          onClose={this.handleEditClose}
        >
          <DialogTitle>{t('edit_user')}</DialogTitle>
          <DialogContent>
            <TextField
              required
              id='edit_firstName'
              label={t('Name')}
              type='text'
              fullWidth
              variant='standard'
              defaultValue={this.state.edit.first_name}
              inputProps={{ maxLength: 20 }}
            />
            <TextField
              required
              id='edit_lastName'
              label={t('Last_name')}
              type='text'
              fullWidth
              variant='standard'
              defaultValue={this.state.edit.last_name}
              inputProps={{ maxLength: 20 }}
            />
            <TextField
              required
              disabled
              id='edit_email'
              label={t('Email')}
              type='text'
              fullWidth
              variant='standard'
              defaultValue={this.state.edit.email}
              inputProps={{ maxLength: 50 }}
            />
            <TextField
              id='edit_phone'
              label={t('Phone')}
              type='text'
              fullWidth
              variant='standard'
              defaultValue={this.state.edit.phone}
              inputProps={{ maxLength: 20 }}
            />
            <TextField
              id='edit_mobile'
              label={t('Mobile')}
              type='text'
              fullWidth
              variant='standard'
              defaultValue={this.state.edit.mobile}
              inputProps={{ maxLength: 20 }}
              sx={{ pb: 3 }}
            />
            <Button
              variant='contained'
              sx={{ m: 2 }}
              size='small'
              onClick={() => this.handleResetOpen(user)}
            >
              {t('reset_password')}
            </Button>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleEditClose}>{t('Cancel')}</Button>
            <Button onClick={() => this.update(this.state.edit)}>
              {t('Save')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={!_.isEmpty(this.state.settings)}
          onClose={this.handleSettingsClose}
        >
          <DialogContent>
            <Permissions user={user} />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleSettingsClose}>{t('Close')}</Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={this.state.snackbarInfoOpen}
          autoHideDuration={4000}
          onClose={this.handleSnackbarClose}
          key={'bottomcentererror'}
        >
          <Alert elevation={6} variant='filled' severity='info'>
            {t('password_sent')}
          </Alert>
        </Snackbar>
      </ListItem>
    )
  }
}

export default withTranslation()(UserListItem)
